import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetBatchUsersProgressQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.UsersFilters>;
  journeyStepId: Types.Scalars['String']['input'];
  batchId: Types.Scalars['String']['input'];
}>;


export type GetBatchUsersProgressQuery = { users: { totalCount: number, success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, edges?: Array<{ node: { name?: string | null, id: string, emailId?: string | null, profilePicture?: string | null, journeyPerformance?: { progress: number, isLocked: boolean, status: Types.JourneyPerformanceStatusEnum } | null } }> | null, pageInfo?: { endCursor?: string | null, hasNextPage?: boolean | null } | null } };


export const GetBatchUsersProgressDocument = /*#__PURE__*/ gql`
    query getBatchUsersProgress($filters: UsersFilters, $journeyStepId: String!, $batchId: String!) {
  users(filters: $filters) {
    edges {
      node {
        name
        id
        emailId
        profilePicture
        journeyPerformance(journeyStepId: $journeyStepId, batchId: $batchId) {
          progress
          isLocked
          status
        }
      }
    }
    totalCount
    success
    errorCode
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

export function useGetBatchUsersProgressQuery(options: Omit<Urql.UseQueryArgs<GetBatchUsersProgressQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBatchUsersProgressQuery, GetBatchUsersProgressQueryVariables>({ query: GetBatchUsersProgressDocument, ...options });
};